<template>
  <button @click="toggleFilter" class="btn btn-default btn-compact m-r-sm">
    <i class="fa" :class="showingArchived ? 'fa-eye-slash' : 'fa-eye'"></i>
    <span class="hidden-xs">{{ showingArchived ? 'Hide Archived' : 'Show Archived' }}</span>
  </button>
</template>

<script>
export default {
  name: 'filter-archive-button',
  props: {
    initialType: {
      type: String,
      default: 'not_archived'
    }
  },
  data() {
    return {
      showingArchived: false
    };
  },
  methods: {
    toggleFilter() {
      this.showingArchived = !this.showingArchived;
      
      if (this.showingArchived) {
        // Show all sessions including archived
        this.$notificationManager.$emit('update-search-base-url', {
          baseUrl: '/api/v1/paid_sessions'
        });
      } else {
        // Show only non-archived sessions
        this.$notificationManager.$emit('update-search-base-url', {
          baseUrl: '/api/v1/paid_sessions?type=not_archived'
        });
      }
      
      // Notify the user that the filter has changed
      const message = this.showingArchived ? 'Showing all sessions including archived' : 'Hiding archived sessions';
      this.$notificationManager.$emit('show-toast', message, true);
    }
  }
};
</script>